import React, { Component } from "react";
import { connect } from 'react-redux';

//material ui components
import Grid from '@material-ui/core/Grid';

//material components
import Paper from '@material-ui/core/Paper';
import Moment from 'moment';


class DeleteActivityModal extends Component {
    constructor(props) {
        super();
        this.state = {
            open: false,
            //Resize
            rootFontSize: {
                name: 'xs',
                fontSize: '58%',
                maxWidht: 970,
            },
        };
    }

    componentWillMount() {
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.resize.bind(this));
    }

    componentDidMount(){
        const activity = this.props.activity? this.props.activity:{};

        this.setState({hasRecurrence: activity.scheduleData?.endDateForRecurrency ? true : false})
    }

    resize() {
        this.setState({ isMobile: window.innerWidth <= 960 });

        const sizes = {
            xs: {
                name: 'xs',
                fontSize: '58%',
                maxWidht: 600,
            },
            sm: {
                name: 'sm',
                fontSize: '60%',
                maxWidht: 1024,
            },
            md: {
                name: 'md',
                fontSize: '80%',
                maxWidht: 1880,
            },
            lg: {
                name: 'lg',
                fontSize: '100%',
                maxWidht: 1920,
            },
        };

        const windowWidht = window.innerWidth;
        const windowHeiht = window.innerHeight;

        let rootFontSize = sizes.xs;

        if (windowWidht > sizes.md.maxWidht) {
            rootFontSize = sizes.lg;
        } else if (windowWidht > sizes.sm.maxWidht) {
            rootFontSize = sizes.md;
        } else if (windowWidht > sizes.xs.maxWidht) {
            rootFontSize = sizes.sm;
        } else {
            rootFontSize = sizes.xs;
        }


        this.setState({
            rootFontSize: rootFontSize,
            windowWidht: windowWidht,
            windowHeiht: windowHeiht,
        });
    }


    //#region  Inner components
    getCorrectTime(activity, timeZoneName) {

        if (activity?.date && activity?.endDate && timeZoneName) {

            const dateStartTimeZone = new Date(new Date(activity.date).toLocaleString("en-US", { timeZone: timeZoneName }));
            const dateEndTimeZone = new Date(new Date(activity.endDate).toLocaleString("en-US", { timeZone: timeZoneName }));

            return `${Moment(dateStartTimeZone).format("MMM D, YYYY")}, ${Moment(dateStartTimeZone).format('LT')} - ${Moment(dateEndTimeZone).format('LT')}`;
        }
        else {
            return ``;
        }
    };

    RenderModalContent = ({ activity }) => {


        return (
            <Grid>
                <Paper elevation={3} className="paperModalMenuItem" square='false' color='secondary'>
                    <Grid id='menu_item_deletetion_modal' container justify='flex-start' alignItems='baseline' style={{ height: '100%' }} >
                        {/* Title and subtitle */}
                        <Grid item container alignItems='center' className="TitleRepairsModal">Confirm Activity Deletion</Grid>
                        <Grid item container className="RepairsModalContainer">
                            <Grid item container justify='center' alignItems='center' className="subtitleMenuItemModal">
                                <Grid item xs={10} md={10} lg={8}>
                                    Are you sure you want to delete this activity?
                                </Grid>
                            </Grid>

                            {/* Activity Info */}
                            
                            <Grid item container justify='center' alignItems='flex-start' className="ModalmenuItemsContainer">
                               {
                                    (activity) &&
                                    <Grid id={`activity_${activity._id}`} item container className="padding5">
                                        <Grid item direction="row" spacing={0} className="menuItemBackground alingCenter">
                                            <Grid item xs={12}>
                                                {/* Image */}
                                                <Grid item container className="alingCenter" >
                                                    {
                                                        (activity?.thumbnailImageUrl || activity?.backgroundUrl) ?
                                                            <img
                                                             className="MenuItemImg"
                                                             src={activity.thumbnailImageUrl? activity.thumbnailImageUrl : activity.backgroundUrl}
                                                             alt={activity.title}
                                                            />
                                                            :
                                                            <Grid item className="altResidentName">{activity.title}</Grid>
                                                     }
                                                 </Grid>
                                             </Grid>
                                            <Grid item xs={12}>
                                                {/* Activity name */}
                                                <Grid item container className="alingLeftName padding5">
                                                    {
                                                        (activity?.title) ?
                                                            activity.title
                                                            :
                                                            'N/A'
                                                    }
                                                </Grid>
                                            </Grid>
                                            <Grid item xs={12}>
                                            {/* time */}
                                                <Grid item container className="alingLeftServeTime padding5">
                                                    {
                                                        this.getCorrectTime(activity, this.props.timeZoneName)
                                                    }
                                                </Grid>
                                            </Grid>
                                         </Grid>
                                     </Grid>
                               }
                            </Grid>

                            {/* Buttons */}
                            
                            <Grid item container className="ModalButtonsContainer alingCenter" justify='flex-end'>
                                {
                                    this.state.hasRecurrence?
                                    <Grid item container className="alingCenter" direction='row'>
                                        <Grid item container className="MenuItemModalButtonNoRecurrence alingCenter">
                                            <Grid id='close_repair_return_btn' item container className="alingCenter" onClick={() => this.props.OnCancelHandler()}>
                                            No, Exit
                                            </Grid>
                                        </Grid>
                                        <Grid item container className="MenuItemModalButtonYesPurple alingCenter">
                                            <Grid id='close_repair_close_btn' item container style={{ width: '70%'}} className="alingCenter" onClick={() => this.props.OnDeleteHandler()}>
                                                Yes, Delete This Occurrence
                                            </Grid>
                                        </Grid>
                                        <Grid item container className="MenuItemModalButtonYesRed alingCenter">
                                            <Grid id='close_repair_close_btn' item container style={{ width: '70%'}} className="alingCenter" onClick={() => this.props.OnDeleteRecurrenceHandler()}>
                                                Yes, Delete All Occurrences
                                            </Grid>
                                         </Grid>
                                     </Grid>
                                     :
                                     <Grid item container className="alingCenter" direction='row'>
                                         <Grid item container className="MenuItemModalButtonNo alingCenter">
                                             <Grid id='cancel_repair_return_btn' item container className="alingCenter" onClick={() => this.props.OnCancelHandler()}>
                                                 No, Exit
                                             </Grid>
                                         </Grid>
                                         <Grid item container className="MenuItemModalButtonYes alingCenter">
                                             <Grid id='cancel_repair_cancel_btn' item container className="alingCenter" onClick={() => this.props.OnDeleteHandler()}>
                                                 Yes, Delete
                                             </Grid>
                                         </Grid>
                                     </Grid>
                                }
                            </Grid>
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>
        );
    };



    render() {
        return (
            <main style={{}}>
                <div>
                    <this.RenderModalContent activity={this.props.activity ? this.props.activity : {}} />
                </div>
            </main>
        )
    }
}

function mapStateToProps(state, dispatch) {
    const activitiesData = (state.activityReducer && state.activityReducer.activityData?.data) ? state.activityReducer.activityData.data : [];

    return {
        activitiesData
    }
}


export default connect(mapStateToProps, {})(DeleteActivityModal);

